import { UserModel } from "types";
import { canAccessSite, canManageSite } from "utils";

export interface IncidentAccess {
  /** Nurse, manager, or director of care on this home. */
  canDocument: boolean;
  /** Manager or director of care. Confirms dismissals and reviews locked records. */
  canSupervise: boolean;
}

/**
 * Same tenancy as threats. Super sees every home. A site member with role
 * "user" documents. Site role "admin" supervises. A platform admin with no
 * membership on that home does not. Fixture preview can pass an override.
 */
export function incidentAccess(
  user: UserModel | null | undefined,
  facilityId: string | undefined,
  previewRole?: "nurse" | "supervisor"
): IncidentAccess {
  if (previewRole) {
    return { canDocument: true, canSupervise: previewRole === "supervisor" };
  }
  if (!user || !facilityId) return { canDocument: false, canSupervise: false };
  if (user.type === "super") return { canDocument: true, canSupervise: true };
  if (!canAccessSite(user, facilityId)) return { canDocument: false, canSupervise: false };
  return { canDocument: true, canSupervise: canManageSite(user, facilityId) };
}

export function canOpenConfirmationQueue(
  user: UserModel | null | undefined,
  previewRole?: "nurse" | "supervisor"
): boolean {
  if (previewRole === "supervisor") return true;
  if (!user) return false;
  if (user.type === "super") return true;
  return Boolean(user.sites?.some((site) => site.role === "admin"));
}
